import { render, staticRenderFns } from "./menuUser.vue?vue&type=template&id=3f11923f"
import script from "./menuUser.vue?vue&type=script&lang=js"
export * from "./menuUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports